import { COMPACTING_DIVISION_AUTHORIZED_BTN, COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS, NAVIGATE_COMPACTING_DIV_AUTHORIZATION, NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS } from "./compactingDivAuthorization.actionsType";



export const COMPACTING_AUTHORIZATION = 'compactingDivAuthorization';

let initialState = {
    loading: false,
    compactingDivAuthData: [],
    errorMessage: '',
    iscompactingDivAuth: false,
    compactingDivAuthSelectedvalue: null,
    verifyCompacting:'',
    compactingAuthDetailsData: []
}

export let  compactingDivAuthorizationReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {

        case FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST:
        case UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST:
        case FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDivAuthData: updatePayload
            }
        case UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS:
            return {
                ...state,
                loading: false,
                verifyCompacting: updatePayload
            }
        case FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    compactingAuthDetailsData: updatePayload,
                    
                } 
        case FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE:
        case UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE:
        case FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE:
                return {
                    ...state,
                    loading: false,
                    compactingDivAuthData: updatePayload
                }
        case NAVIGATE_COMPACTING_DIV_AUTHORIZATION:
            return {
                ...state,
                iscompactingDivAuth: false,
                
            }
        case COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET:
            return {
                ...state,
                Authreset: false,
                verifyCompacting: '',
            }
        case COMPACTING_DIVISION_AUTHORIZED_BTN:
                return {
                    ...state,
                    Authreset: true,
                    verifyCompacting: '',
                }

        case NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS:
            return {
                ...state,
                iscompactingDivAuth: true,
                loading: false,
                compactingDivAuthSelectedvalue: updatePayload.compactingDivAuthSelectedvalue
            }
                default:
                    return state;
            }
        };